/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StartRouteImport } from './routes/start'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HomeRouteImport } from './routes/home'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FollowupsRouteImport } from './routes/followups'
import { Route as CreativeRouteImport } from './routes/creative'
import { Route as ChannelsRouteImport } from './routes/channels'
import { Route as CampaignsRouteImport } from './routes/campaigns'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as BrandsRouteImport } from './routes/brands'
import { Route as BrandRouteImport } from './routes/brand'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AcceptRouteImport } from './routes/accept'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DesignerIndexRouteImport } from './routes/designer.index'
import { Route as VetoTokenRouteImport } from './routes/veto.$token'
import { Route as SettingsWorkspaceRouteImport } from './routes/settings.workspace'
import { Route as SettingsTeamRouteImport } from './routes/settings.team'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsAdAccountsRouteImport } from './routes/settings.ad-accounts'
import { Route as ResetPasswordSuccessRouteImport } from './routes/reset-password.success'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding.welcome'
import { Route as OnboardingUrlRouteImport } from './routes/onboarding.url'
import { Route as OnboardingPlanRouteImport } from './routes/onboarding.plan'
import { Route as MetaConnectErrorRouteImport } from './routes/meta-connect.error'
import { Route as McpAuthorizeRouteImport } from './routes/mcp.authorize'
import { Route as MagicLinkSentRouteImport } from './routes/magic-link.sent'
import { Route as ForgotPasswordSentRouteImport } from './routes/forgot-password.sent'
import { Route as DevTemplatesRouteImport } from './routes/dev.templates'
import { Route as DevTemplateProbeRouteImport } from './routes/dev.template-probe'
import { Route as DevPreviewRouteImport } from './routes/dev.preview'
import { Route as DesignerUploadRouteImport } from './routes/designer.upload'
import { Route as CampaignsImportRouteImport } from './routes/campaigns.import'
import { Route as BriefVoiceRouteImport } from './routes/brief.voice'
import { Route as BriefCustomerRouteImport } from './routes/brief.customer'
import { Route as BrandSlugRouteImport } from './routes/brand.$slug'
import { Route as AdminTrustRouteImport } from './routes/admin.trust'
import { Route as AdminStrategistRouteImport } from './routes/admin.strategist'
import { Route as AdminLlmCostsRouteImport } from './routes/admin.llm-costs'
import { Route as RenderCreativeIdRouteImport } from './routes/render.creative.$id'
import { Route as CampaignsNewBriefRouteImport } from './routes/campaigns.new.brief'
import { Route as CampaignsImportedIdRouteImport } from './routes/campaigns.imported.$id'
import { Route as BrandSlugSiteRouteImport } from './routes/brand.$slug.site'
import { Route as BrandSlugSettingsRouteImport } from './routes/brand.$slug.settings'
import { Route as BrandSlugLibraryRouteImport } from './routes/brand.$slug.library'
import { Route as BrandSlugHomeRouteImport } from './routes/brand.$slug.home'
import { Route as BrandSlugFollowupsRouteImport } from './routes/brand.$slug.followups'
import { Route as BrandSlugCreativeRouteImport } from './routes/brand.$slug.creative'
import { Route as BrandSlugCampaignsRouteImport } from './routes/brand.$slug.campaigns'
import { Route as BrandSlugCalendarRouteImport } from './routes/brand.$slug.calendar'
import { Route as BrandSlugBriefRouteImport } from './routes/brand.$slug.brief'
import { Route as BrandSlugAnalyticsRouteImport } from './routes/brand.$slug.analytics'
import { Route as BrandSlugBrandRouteImport } from './routes/brand.$slug._brand'
import { Route as BrandSlugSettingsIndexRouteImport } from './routes/brand.$slug.settings.index'
import { Route as BrandSlugMemosIndexRouteImport } from './routes/brand.$slug.memos.index'
import { Route as BrandSlugChannelsIndexRouteImport } from './routes/brand.$slug.channels.index'
import { Route as BrandSlugCampaignsIndexRouteImport } from './routes/brand.$slug.campaigns.index'
import { Route as BrandSlugBriefIndexRouteImport } from './routes/brand.$slug.brief.index'
import { Route as CampaignsNewReviewIdRouteImport } from './routes/campaigns.new.review.$id'
import { Route as CampaignsNewLaunchedIdRouteImport } from './routes/campaigns.new.launched.$id'
import { Route as CampaignsNewDraftingIdRouteImport } from './routes/campaigns.new.drafting.$id'
import { Route as BrandSlugSettingsStrategyRouteImport } from './routes/brand.$slug.settings.strategy'
import { Route as BrandSlugSettingsSpendRouteImport } from './routes/brand.$slug.settings.spend'
import { Route as BrandSlugSettingsNotificationsRouteImport } from './routes/brand.$slug.settings.notifications'
import { Route as BrandSlugSettingsIntegrationsRouteImport } from './routes/brand.$slug.settings.integrations'
import { Route as BrandSlugSettingsDangerRouteImport } from './routes/brand.$slug.settings.danger'
import { Route as BrandSlugSettingsCommunicationRouteImport } from './routes/brand.$slug.settings.communication'
import { Route as BrandSlugSettingsAuthorityRouteImport } from './routes/brand.$slug.settings.authority'
import { Route as BrandSlugSettingsAiToolRouteImport } from './routes/brand.$slug.settings.ai-tool'
import { Route as BrandSlugOnboardingUrlRouteImport } from './routes/brand.$slug.onboarding.url'
import { Route as BrandSlugOnboardingScrapeRouteImport } from './routes/brand.$slug.onboarding.scrape'
import { Route as BrandSlugOnboardingMarketsRouteImport } from './routes/brand.$slug.onboarding.markets'
import { Route as BrandSlugOnboardingCompetitionRouteImport } from './routes/brand.$slug.onboarding.competition'
import { Route as BrandSlugOnboardingAssetsRouteImport } from './routes/brand.$slug.onboarding.assets'
import { Route as BrandSlugMetaConnectPickerRouteImport } from './routes/brand.$slug.meta-connect.picker'
import { Route as BrandSlugMetaConnectErrorRouteImport } from './routes/brand.$slug.meta-connect.error'
import { Route as BrandSlugMetaConnectAdAccountRouteImport } from './routes/brand.$slug.meta-connect.ad-account'
import { Route as BrandSlugMemosMemoIdRouteImport } from './routes/brand.$slug.memos.$memoId'
import { Route as BrandSlugGoogleConnectPickerRouteImport } from './routes/brand.$slug.google-connect.picker'
import { Route as BrandSlugGoogleConnectErrorRouteImport } from './routes/brand.$slug.google-connect.error'
import { Route as BrandSlugChannelsKindRouteImport } from './routes/brand.$slug.channels.$kind'
import { Route as BrandSlugCampaignsImportRouteImport } from './routes/brand.$slug.campaigns.import'
import { Route as BrandSlugCampaignsIdRouteImport } from './routes/brand.$slug.campaigns.$id'
import { Route as BrandSlugBriefVoiceRouteImport } from './routes/brand.$slug.brief.voice'
import { Route as BrandSlugBriefCustomerRouteImport } from './routes/brand.$slug.brief.customer'
import { Route as BrandSlugBriefConfirmRouteImport } from './routes/brand.$slug.brief.confirm'
import { Route as BrandSlugBrandVoiceSamplesRouteImport } from './routes/brand.$slug._brand.voice-samples'
import { Route as BrandSlugBrandVoiceRouteImport } from './routes/brand.$slug._brand.voice'
import { Route as BrandSlugBrandVisualsRouteImport } from './routes/brand.$slug._brand.visuals'
import { Route as BrandSlugBrandTestimonialsRouteImport } from './routes/brand.$slug._brand.testimonials'
import { Route as BrandSlugBrandTeamRouteImport } from './routes/brand.$slug._brand.team'
import { Route as BrandSlugBrandSummaryRouteImport } from './routes/brand.$slug._brand.summary'
import { Route as BrandSlugBrandSiteContextRouteImport } from './routes/brand.$slug._brand.site-context'
import { Route as BrandSlugBrandProductsRouteImport } from './routes/brand.$slug._brand.products'
import { Route as BrandSlugBrandIdentityRouteImport } from './routes/brand.$slug._brand.identity'
import { Route as BrandSlugBrandDesignSystemRouteImport } from './routes/brand.$slug._brand.design-system'
import { Route as BrandSlugBrandCustomerRouteImport } from './routes/brand.$slug._brand.customer'
import { Route as BrandSlugBrandCreativePoolRouteImport } from './routes/brand.$slug._brand.creative-pool'
import { Route as BrandSlugBrandCompetitionRouteImport } from './routes/brand.$slug._brand.competition'
import { Route as BrandSlugBrandAssetsRouteImport } from './routes/brand.$slug._brand.assets'
import { Route as BrandSlugCampaignsNewBriefRouteImport } from './routes/brand.$slug.campaigns.new.brief'
import { Route as BrandSlugCampaignsImportedIdRouteImport } from './routes/brand.$slug.campaigns.imported.$id'
import { Route as BrandSlugAutonomousActionsIdVetoRouteImport } from './routes/brand.$slug.autonomous-actions.$id.veto'
import { Route as BrandSlugCampaignsNewReviewIdRouteImport } from './routes/brand.$slug.campaigns.new.review.$id'
import { Route as BrandSlugCampaignsNewLaunchedIdRouteImport } from './routes/brand.$slug.campaigns.new.launched.$id'
import { Route as BrandSlugCampaignsNewDraftingIdRouteImport } from './routes/brand.$slug.campaigns.new.drafting.$id'

const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowupsRoute = FollowupsRouteImport.update({
  id: '/followups',
  path: '/followups',
  getParentRoute: () => rootRouteImport,
} as any)
const CreativeRoute = CreativeRouteImport.update({
  id: '/creative',
  path: '/creative',
  getParentRoute: () => rootRouteImport,
} as any)
const ChannelsRoute = ChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const BriefRoute = BriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsRoute = BrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandRoute = BrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptRoute = AcceptRouteImport.update({
  id: '/accept',
  path: '/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignerIndexRoute = DesignerIndexRouteImport.update({
  id: '/designer/',
  path: '/designer/',
  getParentRoute: () => rootRouteImport,
} as any)
const VetoTokenRoute = VetoTokenRouteImport.update({
  id: '/veto/$token',
  path: '/veto/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWorkspaceRoute = SettingsWorkspaceRouteImport.update({
  id: '/settings/workspace',
  path: '/settings/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/settings/team',
  path: '/settings/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAdAccountsRoute = SettingsAdAccountsRouteImport.update({
  id: '/settings/ad-accounts',
  path: '/settings/ad-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordSuccessRoute = ResetPasswordSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => ResetPasswordRoute,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/onboarding/welcome',
  path: '/onboarding/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingUrlRoute = OnboardingUrlRouteImport.update({
  id: '/onboarding/url',
  path: '/onboarding/url',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPlanRoute = OnboardingPlanRouteImport.update({
  id: '/onboarding/plan',
  path: '/onboarding/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const MetaConnectErrorRoute = MetaConnectErrorRouteImport.update({
  id: '/meta-connect/error',
  path: '/meta-connect/error',
  getParentRoute: () => rootRouteImport,
} as any)
const McpAuthorizeRoute = McpAuthorizeRouteImport.update({
  id: '/mcp/authorize',
  path: '/mcp/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLinkSentRoute = MagicLinkSentRouteImport.update({
  id: '/magic-link/sent',
  path: '/magic-link/sent',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordSentRoute = ForgotPasswordSentRouteImport.update({
  id: '/sent',
  path: '/sent',
  getParentRoute: () => ForgotPasswordRoute,
} as any)
const DevTemplatesRoute = DevTemplatesRouteImport.update({
  id: '/dev/templates',
  path: '/dev/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const DevTemplateProbeRoute = DevTemplateProbeRouteImport.update({
  id: '/dev/template-probe',
  path: '/dev/template-probe',
  getParentRoute: () => rootRouteImport,
} as any)
const DevPreviewRoute = DevPreviewRouteImport.update({
  id: '/dev/preview',
  path: '/dev/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignerUploadRoute = DesignerUploadRouteImport.update({
  id: '/designer/upload',
  path: '/designer/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsImportRoute = CampaignsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => CampaignsRoute,
} as any)
const BriefVoiceRoute = BriefVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => BriefRoute,
} as any)
const BriefCustomerRoute = BriefCustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => BriefRoute,
} as any)
const BrandSlugRoute = BrandSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BrandRoute,
} as any)
const AdminTrustRoute = AdminTrustRouteImport.update({
  id: '/admin/trust',
  path: '/admin/trust',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStrategistRoute = AdminStrategistRouteImport.update({
  id: '/admin/strategist',
  path: '/admin/strategist',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLlmCostsRoute = AdminLlmCostsRouteImport.update({
  id: '/admin/llm-costs',
  path: '/admin/llm-costs',
  getParentRoute: () => rootRouteImport,
} as any)
const RenderCreativeIdRoute = RenderCreativeIdRouteImport.update({
  id: '/render/creative/$id',
  path: '/render/creative/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsNewBriefRoute = CampaignsNewBriefRouteImport.update({
  id: '/new/brief',
  path: '/new/brief',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsImportedIdRoute = CampaignsImportedIdRouteImport.update({
  id: '/imported/$id',
  path: '/imported/$id',
  getParentRoute: () => CampaignsRoute,
} as any)
const BrandSlugSiteRoute = BrandSlugSiteRouteImport.update({
  id: '/site',
  path: '/site',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugSettingsRoute = BrandSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugLibraryRoute = BrandSlugLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugHomeRoute = BrandSlugHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugFollowupsRoute = BrandSlugFollowupsRouteImport.update({
  id: '/followups',
  path: '/followups',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugCreativeRoute = BrandSlugCreativeRouteImport.update({
  id: '/creative',
  path: '/creative',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugCampaignsRoute = BrandSlugCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugCalendarRoute = BrandSlugCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugBriefRoute = BrandSlugBriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugAnalyticsRoute = BrandSlugAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugBrandRoute = BrandSlugBrandRouteImport.update({
  id: '/_brand',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugSettingsIndexRoute = BrandSlugSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrandSlugSettingsRoute,
} as any)
const BrandSlugMemosIndexRoute = BrandSlugMemosIndexRouteImport.update({
  id: '/memos/',
  path: '/memos/',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugChannelsIndexRoute = BrandSlugChannelsIndexRouteImport.update({
  id: '/channels/',
  path: '/channels/',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugCampaignsIndexRoute = BrandSlugCampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrandSlugCampaignsRoute,
} as any)
const BrandSlugBriefIndexRoute = BrandSlugBriefIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BrandSlugBriefRoute,
} as any)
const CampaignsNewReviewIdRoute = CampaignsNewReviewIdRouteImport.update({
  id: '/new/review/$id',
  path: '/new/review/$id',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsNewLaunchedIdRoute = CampaignsNewLaunchedIdRouteImport.update({
  id: '/new/launched/$id',
  path: '/new/launched/$id',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsNewDraftingIdRoute = CampaignsNewDraftingIdRouteImport.update({
  id: '/new/drafting/$id',
  path: '/new/drafting/$id',
  getParentRoute: () => CampaignsRoute,
} as any)
const BrandSlugSettingsStrategyRoute =
  BrandSlugSettingsStrategyRouteImport.update({
    id: '/strategy',
    path: '/strategy',
    getParentRoute: () => BrandSlugSettingsRoute,
  } as any)
const BrandSlugSettingsSpendRoute = BrandSlugSettingsSpendRouteImport.update({
  id: '/spend',
  path: '/spend',
  getParentRoute: () => BrandSlugSettingsRoute,
} as any)
const BrandSlugSettingsNotificationsRoute =
  BrandSlugSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => BrandSlugSettingsRoute,
  } as any)
const BrandSlugSettingsIntegrationsRoute =
  BrandSlugSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => BrandSlugSettingsRoute,
  } as any)
const BrandSlugSettingsDangerRoute = BrandSlugSettingsDangerRouteImport.update({
  id: '/danger',
  path: '/danger',
  getParentRoute: () => BrandSlugSettingsRoute,
} as any)
const BrandSlugSettingsCommunicationRoute =
  BrandSlugSettingsCommunicationRouteImport.update({
    id: '/communication',
    path: '/communication',
    getParentRoute: () => BrandSlugSettingsRoute,
  } as any)
const BrandSlugSettingsAuthorityRoute =
  BrandSlugSettingsAuthorityRouteImport.update({
    id: '/authority',
    path: '/authority',
    getParentRoute: () => BrandSlugSettingsRoute,
  } as any)
const BrandSlugSettingsAiToolRoute = BrandSlugSettingsAiToolRouteImport.update({
  id: '/ai-tool',
  path: '/ai-tool',
  getParentRoute: () => BrandSlugSettingsRoute,
} as any)
const BrandSlugOnboardingUrlRoute = BrandSlugOnboardingUrlRouteImport.update({
  id: '/onboarding/url',
  path: '/onboarding/url',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugOnboardingScrapeRoute =
  BrandSlugOnboardingScrapeRouteImport.update({
    id: '/onboarding/scrape',
    path: '/onboarding/scrape',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugOnboardingMarketsRoute =
  BrandSlugOnboardingMarketsRouteImport.update({
    id: '/onboarding/markets',
    path: '/onboarding/markets',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugOnboardingCompetitionRoute =
  BrandSlugOnboardingCompetitionRouteImport.update({
    id: '/onboarding/competition',
    path: '/onboarding/competition',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugOnboardingAssetsRoute =
  BrandSlugOnboardingAssetsRouteImport.update({
    id: '/onboarding/assets',
    path: '/onboarding/assets',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugMetaConnectPickerRoute =
  BrandSlugMetaConnectPickerRouteImport.update({
    id: '/meta-connect/picker',
    path: '/meta-connect/picker',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugMetaConnectErrorRoute =
  BrandSlugMetaConnectErrorRouteImport.update({
    id: '/meta-connect/error',
    path: '/meta-connect/error',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugMetaConnectAdAccountRoute =
  BrandSlugMetaConnectAdAccountRouteImport.update({
    id: '/meta-connect/ad-account',
    path: '/meta-connect/ad-account',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugMemosMemoIdRoute = BrandSlugMemosMemoIdRouteImport.update({
  id: '/memos/$memoId',
  path: '/memos/$memoId',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugGoogleConnectPickerRoute =
  BrandSlugGoogleConnectPickerRouteImport.update({
    id: '/google-connect/picker',
    path: '/google-connect/picker',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugGoogleConnectErrorRoute =
  BrandSlugGoogleConnectErrorRouteImport.update({
    id: '/google-connect/error',
    path: '/google-connect/error',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugChannelsKindRoute = BrandSlugChannelsKindRouteImport.update({
  id: '/channels/$kind',
  path: '/channels/$kind',
  getParentRoute: () => BrandSlugRoute,
} as any)
const BrandSlugCampaignsImportRoute =
  BrandSlugCampaignsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => BrandSlugCampaignsRoute,
  } as any)
const BrandSlugCampaignsIdRoute = BrandSlugCampaignsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BrandSlugCampaignsRoute,
} as any)
const BrandSlugBriefVoiceRoute = BrandSlugBriefVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => BrandSlugBriefRoute,
} as any)
const BrandSlugBriefCustomerRoute = BrandSlugBriefCustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => BrandSlugBriefRoute,
} as any)
const BrandSlugBriefConfirmRoute = BrandSlugBriefConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => BrandSlugBriefRoute,
} as any)
const BrandSlugBrandVoiceSamplesRoute =
  BrandSlugBrandVoiceSamplesRouteImport.update({
    id: '/voice-samples',
    path: '/voice-samples',
    getParentRoute: () => BrandSlugBrandRoute,
  } as any)
const BrandSlugBrandVoiceRoute = BrandSlugBrandVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandVisualsRoute = BrandSlugBrandVisualsRouteImport.update({
  id: '/visuals',
  path: '/visuals',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandTestimonialsRoute =
  BrandSlugBrandTestimonialsRouteImport.update({
    id: '/testimonials',
    path: '/testimonials',
    getParentRoute: () => BrandSlugBrandRoute,
  } as any)
const BrandSlugBrandTeamRoute = BrandSlugBrandTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandSummaryRoute = BrandSlugBrandSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandSiteContextRoute =
  BrandSlugBrandSiteContextRouteImport.update({
    id: '/site-context',
    path: '/site-context',
    getParentRoute: () => BrandSlugBrandRoute,
  } as any)
const BrandSlugBrandProductsRoute = BrandSlugBrandProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandIdentityRoute = BrandSlugBrandIdentityRouteImport.update({
  id: '/identity',
  path: '/identity',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandDesignSystemRoute =
  BrandSlugBrandDesignSystemRouteImport.update({
    id: '/design-system',
    path: '/design-system',
    getParentRoute: () => BrandSlugBrandRoute,
  } as any)
const BrandSlugBrandCustomerRoute = BrandSlugBrandCustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugBrandCreativePoolRoute =
  BrandSlugBrandCreativePoolRouteImport.update({
    id: '/creative-pool',
    path: '/creative-pool',
    getParentRoute: () => BrandSlugBrandRoute,
  } as any)
const BrandSlugBrandCompetitionRoute =
  BrandSlugBrandCompetitionRouteImport.update({
    id: '/competition',
    path: '/competition',
    getParentRoute: () => BrandSlugBrandRoute,
  } as any)
const BrandSlugBrandAssetsRoute = BrandSlugBrandAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => BrandSlugBrandRoute,
} as any)
const BrandSlugCampaignsNewBriefRoute =
  BrandSlugCampaignsNewBriefRouteImport.update({
    id: '/new/brief',
    path: '/new/brief',
    getParentRoute: () => BrandSlugCampaignsRoute,
  } as any)
const BrandSlugCampaignsImportedIdRoute =
  BrandSlugCampaignsImportedIdRouteImport.update({
    id: '/imported/$id',
    path: '/imported/$id',
    getParentRoute: () => BrandSlugCampaignsRoute,
  } as any)
const BrandSlugAutonomousActionsIdVetoRoute =
  BrandSlugAutonomousActionsIdVetoRouteImport.update({
    id: '/autonomous-actions/$id/veto',
    path: '/autonomous-actions/$id/veto',
    getParentRoute: () => BrandSlugRoute,
  } as any)
const BrandSlugCampaignsNewReviewIdRoute =
  BrandSlugCampaignsNewReviewIdRouteImport.update({
    id: '/new/review/$id',
    path: '/new/review/$id',
    getParentRoute: () => BrandSlugCampaignsRoute,
  } as any)
const BrandSlugCampaignsNewLaunchedIdRoute =
  BrandSlugCampaignsNewLaunchedIdRouteImport.update({
    id: '/new/launched/$id',
    path: '/new/launched/$id',
    getParentRoute: () => BrandSlugCampaignsRoute,
  } as any)
const BrandSlugCampaignsNewDraftingIdRoute =
  BrandSlugCampaignsNewDraftingIdRouteImport.update({
    id: '/new/drafting/$id',
    path: '/new/drafting/$id',
    getParentRoute: () => BrandSlugCampaignsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept': typeof AcceptRoute
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/brand': typeof BrandRouteWithChildren
  '/brands': typeof BrandsRoute
  '/brief': typeof BriefRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/channels': typeof ChannelsRoute
  '/creative': typeof CreativeRoute
  '/followups': typeof FollowupsRoute
  '/forgot-password': typeof ForgotPasswordRouteWithChildren
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/admin/llm-costs': typeof AdminLlmCostsRoute
  '/admin/strategist': typeof AdminStrategistRoute
  '/admin/trust': typeof AdminTrustRoute
  '/brand/$slug': typeof BrandSlugRouteWithChildren
  '/brief/customer': typeof BriefCustomerRoute
  '/brief/voice': typeof BriefVoiceRoute
  '/campaigns/import': typeof CampaignsImportRoute
  '/designer/upload': typeof DesignerUploadRoute
  '/dev/preview': typeof DevPreviewRoute
  '/dev/template-probe': typeof DevTemplateProbeRoute
  '/dev/templates': typeof DevTemplatesRoute
  '/forgot-password/sent': typeof ForgotPasswordSentRoute
  '/magic-link/sent': typeof MagicLinkSentRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/meta-connect/error': typeof MetaConnectErrorRoute
  '/onboarding/plan': typeof OnboardingPlanRoute
  '/onboarding/url': typeof OnboardingUrlRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/reset-password/success': typeof ResetPasswordSuccessRoute
  '/settings/ad-accounts': typeof SettingsAdAccountsRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/workspace': typeof SettingsWorkspaceRoute
  '/veto/$token': typeof VetoTokenRoute
  '/designer/': typeof DesignerIndexRoute
  '/brand/$slug/analytics': typeof BrandSlugAnalyticsRoute
  '/brand/$slug/brief': typeof BrandSlugBriefRouteWithChildren
  '/brand/$slug/calendar': typeof BrandSlugCalendarRoute
  '/brand/$slug/campaigns': typeof BrandSlugCampaignsRouteWithChildren
  '/brand/$slug/creative': typeof BrandSlugCreativeRoute
  '/brand/$slug/followups': typeof BrandSlugFollowupsRoute
  '/brand/$slug/home': typeof BrandSlugHomeRoute
  '/brand/$slug/library': typeof BrandSlugLibraryRoute
  '/brand/$slug/settings': typeof BrandSlugSettingsRouteWithChildren
  '/brand/$slug/site': typeof BrandSlugSiteRoute
  '/campaigns/imported/$id': typeof CampaignsImportedIdRoute
  '/campaigns/new/brief': typeof CampaignsNewBriefRoute
  '/render/creative/$id': typeof RenderCreativeIdRoute
  '/brand/$slug/assets': typeof BrandSlugBrandAssetsRoute
  '/brand/$slug/competition': typeof BrandSlugBrandCompetitionRoute
  '/brand/$slug/creative-pool': typeof BrandSlugBrandCreativePoolRoute
  '/brand/$slug/customer': typeof BrandSlugBrandCustomerRoute
  '/brand/$slug/design-system': typeof BrandSlugBrandDesignSystemRoute
  '/brand/$slug/identity': typeof BrandSlugBrandIdentityRoute
  '/brand/$slug/products': typeof BrandSlugBrandProductsRoute
  '/brand/$slug/site-context': typeof BrandSlugBrandSiteContextRoute
  '/brand/$slug/summary': typeof BrandSlugBrandSummaryRoute
  '/brand/$slug/team': typeof BrandSlugBrandTeamRoute
  '/brand/$slug/testimonials': typeof BrandSlugBrandTestimonialsRoute
  '/brand/$slug/visuals': typeof BrandSlugBrandVisualsRoute
  '/brand/$slug/voice': typeof BrandSlugBrandVoiceRoute
  '/brand/$slug/voice-samples': typeof BrandSlugBrandVoiceSamplesRoute
  '/brand/$slug/brief/confirm': typeof BrandSlugBriefConfirmRoute
  '/brand/$slug/brief/customer': typeof BrandSlugBriefCustomerRoute
  '/brand/$slug/brief/voice': typeof BrandSlugBriefVoiceRoute
  '/brand/$slug/campaigns/$id': typeof BrandSlugCampaignsIdRoute
  '/brand/$slug/campaigns/import': typeof BrandSlugCampaignsImportRoute
  '/brand/$slug/channels/$kind': typeof BrandSlugChannelsKindRoute
  '/brand/$slug/google-connect/error': typeof BrandSlugGoogleConnectErrorRoute
  '/brand/$slug/google-connect/picker': typeof BrandSlugGoogleConnectPickerRoute
  '/brand/$slug/memos/$memoId': typeof BrandSlugMemosMemoIdRoute
  '/brand/$slug/meta-connect/ad-account': typeof BrandSlugMetaConnectAdAccountRoute
  '/brand/$slug/meta-connect/error': typeof BrandSlugMetaConnectErrorRoute
  '/brand/$slug/meta-connect/picker': typeof BrandSlugMetaConnectPickerRoute
  '/brand/$slug/onboarding/assets': typeof BrandSlugOnboardingAssetsRoute
  '/brand/$slug/onboarding/competition': typeof BrandSlugOnboardingCompetitionRoute
  '/brand/$slug/onboarding/markets': typeof BrandSlugOnboardingMarketsRoute
  '/brand/$slug/onboarding/scrape': typeof BrandSlugOnboardingScrapeRoute
  '/brand/$slug/onboarding/url': typeof BrandSlugOnboardingUrlRoute
  '/brand/$slug/settings/ai-tool': typeof BrandSlugSettingsAiToolRoute
  '/brand/$slug/settings/authority': typeof BrandSlugSettingsAuthorityRoute
  '/brand/$slug/settings/communication': typeof BrandSlugSettingsCommunicationRoute
  '/brand/$slug/settings/danger': typeof BrandSlugSettingsDangerRoute
  '/brand/$slug/settings/integrations': typeof BrandSlugSettingsIntegrationsRoute
  '/brand/$slug/settings/notifications': typeof BrandSlugSettingsNotificationsRoute
  '/brand/$slug/settings/spend': typeof BrandSlugSettingsSpendRoute
  '/brand/$slug/settings/strategy': typeof BrandSlugSettingsStrategyRoute
  '/campaigns/new/drafting/$id': typeof CampaignsNewDraftingIdRoute
  '/campaigns/new/launched/$id': typeof CampaignsNewLaunchedIdRoute
  '/campaigns/new/review/$id': typeof CampaignsNewReviewIdRoute
  '/brand/$slug/brief/': typeof BrandSlugBriefIndexRoute
  '/brand/$slug/campaigns/': typeof BrandSlugCampaignsIndexRoute
  '/brand/$slug/channels/': typeof BrandSlugChannelsIndexRoute
  '/brand/$slug/memos/': typeof BrandSlugMemosIndexRoute
  '/brand/$slug/settings/': typeof BrandSlugSettingsIndexRoute
  '/brand/$slug/autonomous-actions/$id/veto': typeof BrandSlugAutonomousActionsIdVetoRoute
  '/brand/$slug/campaigns/imported/$id': typeof BrandSlugCampaignsImportedIdRoute
  '/brand/$slug/campaigns/new/brief': typeof BrandSlugCampaignsNewBriefRoute
  '/brand/$slug/campaigns/new/drafting/$id': typeof BrandSlugCampaignsNewDraftingIdRoute
  '/brand/$slug/campaigns/new/launched/$id': typeof BrandSlugCampaignsNewLaunchedIdRoute
  '/brand/$slug/campaigns/new/review/$id': typeof BrandSlugCampaignsNewReviewIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept': typeof AcceptRoute
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/brand': typeof BrandRouteWithChildren
  '/brands': typeof BrandsRoute
  '/brief': typeof BriefRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/channels': typeof ChannelsRoute
  '/creative': typeof CreativeRoute
  '/followups': typeof FollowupsRoute
  '/forgot-password': typeof ForgotPasswordRouteWithChildren
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/admin/llm-costs': typeof AdminLlmCostsRoute
  '/admin/strategist': typeof AdminStrategistRoute
  '/admin/trust': typeof AdminTrustRoute
  '/brand/$slug': typeof BrandSlugRouteWithChildren
  '/brief/customer': typeof BriefCustomerRoute
  '/brief/voice': typeof BriefVoiceRoute
  '/campaigns/import': typeof CampaignsImportRoute
  '/designer/upload': typeof DesignerUploadRoute
  '/dev/preview': typeof DevPreviewRoute
  '/dev/template-probe': typeof DevTemplateProbeRoute
  '/dev/templates': typeof DevTemplatesRoute
  '/forgot-password/sent': typeof ForgotPasswordSentRoute
  '/magic-link/sent': typeof MagicLinkSentRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/meta-connect/error': typeof MetaConnectErrorRoute
  '/onboarding/plan': typeof OnboardingPlanRoute
  '/onboarding/url': typeof OnboardingUrlRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/reset-password/success': typeof ResetPasswordSuccessRoute
  '/settings/ad-accounts': typeof SettingsAdAccountsRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/workspace': typeof SettingsWorkspaceRoute
  '/veto/$token': typeof VetoTokenRoute
  '/designer': typeof DesignerIndexRoute
  '/brand/$slug/analytics': typeof BrandSlugAnalyticsRoute
  '/brand/$slug/calendar': typeof BrandSlugCalendarRoute
  '/brand/$slug/creative': typeof BrandSlugCreativeRoute
  '/brand/$slug/followups': typeof BrandSlugFollowupsRoute
  '/brand/$slug/home': typeof BrandSlugHomeRoute
  '/brand/$slug/library': typeof BrandSlugLibraryRoute
  '/brand/$slug/site': typeof BrandSlugSiteRoute
  '/campaigns/imported/$id': typeof CampaignsImportedIdRoute
  '/campaigns/new/brief': typeof CampaignsNewBriefRoute
  '/render/creative/$id': typeof RenderCreativeIdRoute
  '/brand/$slug/assets': typeof BrandSlugBrandAssetsRoute
  '/brand/$slug/competition': typeof BrandSlugBrandCompetitionRoute
  '/brand/$slug/creative-pool': typeof BrandSlugBrandCreativePoolRoute
  '/brand/$slug/customer': typeof BrandSlugBrandCustomerRoute
  '/brand/$slug/design-system': typeof BrandSlugBrandDesignSystemRoute
  '/brand/$slug/identity': typeof BrandSlugBrandIdentityRoute
  '/brand/$slug/products': typeof BrandSlugBrandProductsRoute
  '/brand/$slug/site-context': typeof BrandSlugBrandSiteContextRoute
  '/brand/$slug/summary': typeof BrandSlugBrandSummaryRoute
  '/brand/$slug/team': typeof BrandSlugBrandTeamRoute
  '/brand/$slug/testimonials': typeof BrandSlugBrandTestimonialsRoute
  '/brand/$slug/visuals': typeof BrandSlugBrandVisualsRoute
  '/brand/$slug/voice': typeof BrandSlugBrandVoiceRoute
  '/brand/$slug/voice-samples': typeof BrandSlugBrandVoiceSamplesRoute
  '/brand/$slug/brief/confirm': typeof BrandSlugBriefConfirmRoute
  '/brand/$slug/brief/customer': typeof BrandSlugBriefCustomerRoute
  '/brand/$slug/brief/voice': typeof BrandSlugBriefVoiceRoute
  '/brand/$slug/campaigns/$id': typeof BrandSlugCampaignsIdRoute
  '/brand/$slug/campaigns/import': typeof BrandSlugCampaignsImportRoute
  '/brand/$slug/channels/$kind': typeof BrandSlugChannelsKindRoute
  '/brand/$slug/google-connect/error': typeof BrandSlugGoogleConnectErrorRoute
  '/brand/$slug/google-connect/picker': typeof BrandSlugGoogleConnectPickerRoute
  '/brand/$slug/memos/$memoId': typeof BrandSlugMemosMemoIdRoute
  '/brand/$slug/meta-connect/ad-account': typeof BrandSlugMetaConnectAdAccountRoute
  '/brand/$slug/meta-connect/error': typeof BrandSlugMetaConnectErrorRoute
  '/brand/$slug/meta-connect/picker': typeof BrandSlugMetaConnectPickerRoute
  '/brand/$slug/onboarding/assets': typeof BrandSlugOnboardingAssetsRoute
  '/brand/$slug/onboarding/competition': typeof BrandSlugOnboardingCompetitionRoute
  '/brand/$slug/onboarding/markets': typeof BrandSlugOnboardingMarketsRoute
  '/brand/$slug/onboarding/scrape': typeof BrandSlugOnboardingScrapeRoute
  '/brand/$slug/onboarding/url': typeof BrandSlugOnboardingUrlRoute
  '/brand/$slug/settings/ai-tool': typeof BrandSlugSettingsAiToolRoute
  '/brand/$slug/settings/authority': typeof BrandSlugSettingsAuthorityRoute
  '/brand/$slug/settings/communication': typeof BrandSlugSettingsCommunicationRoute
  '/brand/$slug/settings/danger': typeof BrandSlugSettingsDangerRoute
  '/brand/$slug/settings/integrations': typeof BrandSlugSettingsIntegrationsRoute
  '/brand/$slug/settings/notifications': typeof BrandSlugSettingsNotificationsRoute
  '/brand/$slug/settings/spend': typeof BrandSlugSettingsSpendRoute
  '/brand/$slug/settings/strategy': typeof BrandSlugSettingsStrategyRoute
  '/campaigns/new/drafting/$id': typeof CampaignsNewDraftingIdRoute
  '/campaigns/new/launched/$id': typeof CampaignsNewLaunchedIdRoute
  '/campaigns/new/review/$id': typeof CampaignsNewReviewIdRoute
  '/brand/$slug/brief': typeof BrandSlugBriefIndexRoute
  '/brand/$slug/campaigns': typeof BrandSlugCampaignsIndexRoute
  '/brand/$slug/channels': typeof BrandSlugChannelsIndexRoute
  '/brand/$slug/memos': typeof BrandSlugMemosIndexRoute
  '/brand/$slug/settings': typeof BrandSlugSettingsIndexRoute
  '/brand/$slug/autonomous-actions/$id/veto': typeof BrandSlugAutonomousActionsIdVetoRoute
  '/brand/$slug/campaigns/imported/$id': typeof BrandSlugCampaignsImportedIdRoute
  '/brand/$slug/campaigns/new/brief': typeof BrandSlugCampaignsNewBriefRoute
  '/brand/$slug/campaigns/new/drafting/$id': typeof BrandSlugCampaignsNewDraftingIdRoute
  '/brand/$slug/campaigns/new/launched/$id': typeof BrandSlugCampaignsNewLaunchedIdRoute
  '/brand/$slug/campaigns/new/review/$id': typeof BrandSlugCampaignsNewReviewIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept': typeof AcceptRoute
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/brand': typeof BrandRouteWithChildren
  '/brands': typeof BrandsRoute
  '/brief': typeof BriefRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/channels': typeof ChannelsRoute
  '/creative': typeof CreativeRoute
  '/followups': typeof FollowupsRoute
  '/forgot-password': typeof ForgotPasswordRouteWithChildren
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/admin/llm-costs': typeof AdminLlmCostsRoute
  '/admin/strategist': typeof AdminStrategistRoute
  '/admin/trust': typeof AdminTrustRoute
  '/brand/$slug': typeof BrandSlugRouteWithChildren
  '/brief/customer': typeof BriefCustomerRoute
  '/brief/voice': typeof BriefVoiceRoute
  '/campaigns/import': typeof CampaignsImportRoute
  '/designer/upload': typeof DesignerUploadRoute
  '/dev/preview': typeof DevPreviewRoute
  '/dev/template-probe': typeof DevTemplateProbeRoute
  '/dev/templates': typeof DevTemplatesRoute
  '/forgot-password/sent': typeof ForgotPasswordSentRoute
  '/magic-link/sent': typeof MagicLinkSentRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/meta-connect/error': typeof MetaConnectErrorRoute
  '/onboarding/plan': typeof OnboardingPlanRoute
  '/onboarding/url': typeof OnboardingUrlRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/reset-password/success': typeof ResetPasswordSuccessRoute
  '/settings/ad-accounts': typeof SettingsAdAccountsRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/workspace': typeof SettingsWorkspaceRoute
  '/veto/$token': typeof VetoTokenRoute
  '/designer/': typeof DesignerIndexRoute
  '/brand/$slug/_brand': typeof BrandSlugBrandRouteWithChildren
  '/brand/$slug/analytics': typeof BrandSlugAnalyticsRoute
  '/brand/$slug/brief': typeof BrandSlugBriefRouteWithChildren
  '/brand/$slug/calendar': typeof BrandSlugCalendarRoute
  '/brand/$slug/campaigns': typeof BrandSlugCampaignsRouteWithChildren
  '/brand/$slug/creative': typeof BrandSlugCreativeRoute
  '/brand/$slug/followups': typeof BrandSlugFollowupsRoute
  '/brand/$slug/home': typeof BrandSlugHomeRoute
  '/brand/$slug/library': typeof BrandSlugLibraryRoute
  '/brand/$slug/settings': typeof BrandSlugSettingsRouteWithChildren
  '/brand/$slug/site': typeof BrandSlugSiteRoute
  '/campaigns/imported/$id': typeof CampaignsImportedIdRoute
  '/campaigns/new/brief': typeof CampaignsNewBriefRoute
  '/render/creative/$id': typeof RenderCreativeIdRoute
  '/brand/$slug/_brand/assets': typeof BrandSlugBrandAssetsRoute
  '/brand/$slug/_brand/competition': typeof BrandSlugBrandCompetitionRoute
  '/brand/$slug/_brand/creative-pool': typeof BrandSlugBrandCreativePoolRoute
  '/brand/$slug/_brand/customer': typeof BrandSlugBrandCustomerRoute
  '/brand/$slug/_brand/design-system': typeof BrandSlugBrandDesignSystemRoute
  '/brand/$slug/_brand/identity': typeof BrandSlugBrandIdentityRoute
  '/brand/$slug/_brand/products': typeof BrandSlugBrandProductsRoute
  '/brand/$slug/_brand/site-context': typeof BrandSlugBrandSiteContextRoute
  '/brand/$slug/_brand/summary': typeof BrandSlugBrandSummaryRoute
  '/brand/$slug/_brand/team': typeof BrandSlugBrandTeamRoute
  '/brand/$slug/_brand/testimonials': typeof BrandSlugBrandTestimonialsRoute
  '/brand/$slug/_brand/visuals': typeof BrandSlugBrandVisualsRoute
  '/brand/$slug/_brand/voice': typeof BrandSlugBrandVoiceRoute
  '/brand/$slug/_brand/voice-samples': typeof BrandSlugBrandVoiceSamplesRoute
  '/brand/$slug/brief/confirm': typeof BrandSlugBriefConfirmRoute
  '/brand/$slug/brief/customer': typeof BrandSlugBriefCustomerRoute
  '/brand/$slug/brief/voice': typeof BrandSlugBriefVoiceRoute
  '/brand/$slug/campaigns/$id': typeof BrandSlugCampaignsIdRoute
  '/brand/$slug/campaigns/import': typeof BrandSlugCampaignsImportRoute
  '/brand/$slug/channels/$kind': typeof BrandSlugChannelsKindRoute
  '/brand/$slug/google-connect/error': typeof BrandSlugGoogleConnectErrorRoute
  '/brand/$slug/google-connect/picker': typeof BrandSlugGoogleConnectPickerRoute
  '/brand/$slug/memos/$memoId': typeof BrandSlugMemosMemoIdRoute
  '/brand/$slug/meta-connect/ad-account': typeof BrandSlugMetaConnectAdAccountRoute
  '/brand/$slug/meta-connect/error': typeof BrandSlugMetaConnectErrorRoute
  '/brand/$slug/meta-connect/picker': typeof BrandSlugMetaConnectPickerRoute
  '/brand/$slug/onboarding/assets': typeof BrandSlugOnboardingAssetsRoute
  '/brand/$slug/onboarding/competition': typeof BrandSlugOnboardingCompetitionRoute
  '/brand/$slug/onboarding/markets': typeof BrandSlugOnboardingMarketsRoute
  '/brand/$slug/onboarding/scrape': typeof BrandSlugOnboardingScrapeRoute
  '/brand/$slug/onboarding/url': typeof BrandSlugOnboardingUrlRoute
  '/brand/$slug/settings/ai-tool': typeof BrandSlugSettingsAiToolRoute
  '/brand/$slug/settings/authority': typeof BrandSlugSettingsAuthorityRoute
  '/brand/$slug/settings/communication': typeof BrandSlugSettingsCommunicationRoute
  '/brand/$slug/settings/danger': typeof BrandSlugSettingsDangerRoute
  '/brand/$slug/settings/integrations': typeof BrandSlugSettingsIntegrationsRoute
  '/brand/$slug/settings/notifications': typeof BrandSlugSettingsNotificationsRoute
  '/brand/$slug/settings/spend': typeof BrandSlugSettingsSpendRoute
  '/brand/$slug/settings/strategy': typeof BrandSlugSettingsStrategyRoute
  '/campaigns/new/drafting/$id': typeof CampaignsNewDraftingIdRoute
  '/campaigns/new/launched/$id': typeof CampaignsNewLaunchedIdRoute
  '/campaigns/new/review/$id': typeof CampaignsNewReviewIdRoute
  '/brand/$slug/brief/': typeof BrandSlugBriefIndexRoute
  '/brand/$slug/campaigns/': typeof BrandSlugCampaignsIndexRoute
  '/brand/$slug/channels/': typeof BrandSlugChannelsIndexRoute
  '/brand/$slug/memos/': typeof BrandSlugMemosIndexRoute
  '/brand/$slug/settings/': typeof BrandSlugSettingsIndexRoute
  '/brand/$slug/autonomous-actions/$id/veto': typeof BrandSlugAutonomousActionsIdVetoRoute
  '/brand/$slug/campaigns/imported/$id': typeof BrandSlugCampaignsImportedIdRoute
  '/brand/$slug/campaigns/new/brief': typeof BrandSlugCampaignsNewBriefRoute
  '/brand/$slug/campaigns/new/drafting/$id': typeof BrandSlugCampaignsNewDraftingIdRoute
  '/brand/$slug/campaigns/new/launched/$id': typeof BrandSlugCampaignsNewLaunchedIdRoute
  '/brand/$slug/campaigns/new/review/$id': typeof BrandSlugCampaignsNewReviewIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept'
    | '/activity'
    | '/analytics'
    | '/brand'
    | '/brands'
    | '/brief'
    | '/campaigns'
    | '/channels'
    | '/creative'
    | '/followups'
    | '/forgot-password'
    | '/home'
    | '/login'
    | '/notifications'
    | '/profile'
    | '/reset-password'
    | '/signup'
    | '/start'
    | '/admin/llm-costs'
    | '/admin/strategist'
    | '/admin/trust'
    | '/brand/$slug'
    | '/brief/customer'
    | '/brief/voice'
    | '/campaigns/import'
    | '/designer/upload'
    | '/dev/preview'
    | '/dev/template-probe'
    | '/dev/templates'
    | '/forgot-password/sent'
    | '/magic-link/sent'
    | '/mcp/authorize'
    | '/meta-connect/error'
    | '/onboarding/plan'
    | '/onboarding/url'
    | '/onboarding/welcome'
    | '/reset-password/success'
    | '/settings/ad-accounts'
    | '/settings/billing'
    | '/settings/notifications'
    | '/settings/team'
    | '/settings/workspace'
    | '/veto/$token'
    | '/designer/'
    | '/brand/$slug/analytics'
    | '/brand/$slug/brief'
    | '/brand/$slug/calendar'
    | '/brand/$slug/campaigns'
    | '/brand/$slug/creative'
    | '/brand/$slug/followups'
    | '/brand/$slug/home'
    | '/brand/$slug/library'
    | '/brand/$slug/settings'
    | '/brand/$slug/site'
    | '/campaigns/imported/$id'
    | '/campaigns/new/brief'
    | '/render/creative/$id'
    | '/brand/$slug/assets'
    | '/brand/$slug/competition'
    | '/brand/$slug/creative-pool'
    | '/brand/$slug/customer'
    | '/brand/$slug/design-system'
    | '/brand/$slug/identity'
    | '/brand/$slug/products'
    | '/brand/$slug/site-context'
    | '/brand/$slug/summary'
    | '/brand/$slug/team'
    | '/brand/$slug/testimonials'
    | '/brand/$slug/visuals'
    | '/brand/$slug/voice'
    | '/brand/$slug/voice-samples'
    | '/brand/$slug/brief/confirm'
    | '/brand/$slug/brief/customer'
    | '/brand/$slug/brief/voice'
    | '/brand/$slug/campaigns/$id'
    | '/brand/$slug/campaigns/import'
    | '/brand/$slug/channels/$kind'
    | '/brand/$slug/google-connect/error'
    | '/brand/$slug/google-connect/picker'
    | '/brand/$slug/memos/$memoId'
    | '/brand/$slug/meta-connect/ad-account'
    | '/brand/$slug/meta-connect/error'
    | '/brand/$slug/meta-connect/picker'
    | '/brand/$slug/onboarding/assets'
    | '/brand/$slug/onboarding/competition'
    | '/brand/$slug/onboarding/markets'
    | '/brand/$slug/onboarding/scrape'
    | '/brand/$slug/onboarding/url'
    | '/brand/$slug/settings/ai-tool'
    | '/brand/$slug/settings/authority'
    | '/brand/$slug/settings/communication'
    | '/brand/$slug/settings/danger'
    | '/brand/$slug/settings/integrations'
    | '/brand/$slug/settings/notifications'
    | '/brand/$slug/settings/spend'
    | '/brand/$slug/settings/strategy'
    | '/campaigns/new/drafting/$id'
    | '/campaigns/new/launched/$id'
    | '/campaigns/new/review/$id'
    | '/brand/$slug/brief/'
    | '/brand/$slug/campaigns/'
    | '/brand/$slug/channels/'
    | '/brand/$slug/memos/'
    | '/brand/$slug/settings/'
    | '/brand/$slug/autonomous-actions/$id/veto'
    | '/brand/$slug/campaigns/imported/$id'
    | '/brand/$slug/campaigns/new/brief'
    | '/brand/$slug/campaigns/new/drafting/$id'
    | '/brand/$slug/campaigns/new/launched/$id'
    | '/brand/$slug/campaigns/new/review/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept'
    | '/activity'
    | '/analytics'
    | '/brand'
    | '/brands'
    | '/brief'
    | '/campaigns'
    | '/channels'
    | '/creative'
    | '/followups'
    | '/forgot-password'
    | '/home'
    | '/login'
    | '/notifications'
    | '/profile'
    | '/reset-password'
    | '/signup'
    | '/start'
    | '/admin/llm-costs'
    | '/admin/strategist'
    | '/admin/trust'
    | '/brand/$slug'
    | '/brief/customer'
    | '/brief/voice'
    | '/campaigns/import'
    | '/designer/upload'
    | '/dev/preview'
    | '/dev/template-probe'
    | '/dev/templates'
    | '/forgot-password/sent'
    | '/magic-link/sent'
    | '/mcp/authorize'
    | '/meta-connect/error'
    | '/onboarding/plan'
    | '/onboarding/url'
    | '/onboarding/welcome'
    | '/reset-password/success'
    | '/settings/ad-accounts'
    | '/settings/billing'
    | '/settings/notifications'
    | '/settings/team'
    | '/settings/workspace'
    | '/veto/$token'
    | '/designer'
    | '/brand/$slug/analytics'
    | '/brand/$slug/calendar'
    | '/brand/$slug/creative'
    | '/brand/$slug/followups'
    | '/brand/$slug/home'
    | '/brand/$slug/library'
    | '/brand/$slug/site'
    | '/campaigns/imported/$id'
    | '/campaigns/new/brief'
    | '/render/creative/$id'
    | '/brand/$slug/assets'
    | '/brand/$slug/competition'
    | '/brand/$slug/creative-pool'
    | '/brand/$slug/customer'
    | '/brand/$slug/design-system'
    | '/brand/$slug/identity'
    | '/brand/$slug/products'
    | '/brand/$slug/site-context'
    | '/brand/$slug/summary'
    | '/brand/$slug/team'
    | '/brand/$slug/testimonials'
    | '/brand/$slug/visuals'
    | '/brand/$slug/voice'
    | '/brand/$slug/voice-samples'
    | '/brand/$slug/brief/confirm'
    | '/brand/$slug/brief/customer'
    | '/brand/$slug/brief/voice'
    | '/brand/$slug/campaigns/$id'
    | '/brand/$slug/campaigns/import'
    | '/brand/$slug/channels/$kind'
    | '/brand/$slug/google-connect/error'
    | '/brand/$slug/google-connect/picker'
    | '/brand/$slug/memos/$memoId'
    | '/brand/$slug/meta-connect/ad-account'
    | '/brand/$slug/meta-connect/error'
    | '/brand/$slug/meta-connect/picker'
    | '/brand/$slug/onboarding/assets'
    | '/brand/$slug/onboarding/competition'
    | '/brand/$slug/onboarding/markets'
    | '/brand/$slug/onboarding/scrape'
    | '/brand/$slug/onboarding/url'
    | '/brand/$slug/settings/ai-tool'
    | '/brand/$slug/settings/authority'
    | '/brand/$slug/settings/communication'
    | '/brand/$slug/settings/danger'
    | '/brand/$slug/settings/integrations'
    | '/brand/$slug/settings/notifications'
    | '/brand/$slug/settings/spend'
    | '/brand/$slug/settings/strategy'
    | '/campaigns/new/drafting/$id'
    | '/campaigns/new/launched/$id'
    | '/campaigns/new/review/$id'
    | '/brand/$slug/brief'
    | '/brand/$slug/campaigns'
    | '/brand/$slug/channels'
    | '/brand/$slug/memos'
    | '/brand/$slug/settings'
    | '/brand/$slug/autonomous-actions/$id/veto'
    | '/brand/$slug/campaigns/imported/$id'
    | '/brand/$slug/campaigns/new/brief'
    | '/brand/$slug/campaigns/new/drafting/$id'
    | '/brand/$slug/campaigns/new/launched/$id'
    | '/brand/$slug/campaigns/new/review/$id'
  id:
    | '__root__'
    | '/'
    | '/accept'
    | '/activity'
    | '/analytics'
    | '/brand'
    | '/brands'
    | '/brief'
    | '/campaigns'
    | '/channels'
    | '/creative'
    | '/followups'
    | '/forgot-password'
    | '/home'
    | '/login'
    | '/notifications'
    | '/profile'
    | '/reset-password'
    | '/signup'
    | '/start'
    | '/admin/llm-costs'
    | '/admin/strategist'
    | '/admin/trust'
    | '/brand/$slug'
    | '/brief/customer'
    | '/brief/voice'
    | '/campaigns/import'
    | '/designer/upload'
    | '/dev/preview'
    | '/dev/template-probe'
    | '/dev/templates'
    | '/forgot-password/sent'
    | '/magic-link/sent'
    | '/mcp/authorize'
    | '/meta-connect/error'
    | '/onboarding/plan'
    | '/onboarding/url'
    | '/onboarding/welcome'
    | '/reset-password/success'
    | '/settings/ad-accounts'
    | '/settings/billing'
    | '/settings/notifications'
    | '/settings/team'
    | '/settings/workspace'
    | '/veto/$token'
    | '/designer/'
    | '/brand/$slug/_brand'
    | '/brand/$slug/analytics'
    | '/brand/$slug/brief'
    | '/brand/$slug/calendar'
    | '/brand/$slug/campaigns'
    | '/brand/$slug/creative'
    | '/brand/$slug/followups'
    | '/brand/$slug/home'
    | '/brand/$slug/library'
    | '/brand/$slug/settings'
    | '/brand/$slug/site'
    | '/campaigns/imported/$id'
    | '/campaigns/new/brief'
    | '/render/creative/$id'
    | '/brand/$slug/_brand/assets'
    | '/brand/$slug/_brand/competition'
    | '/brand/$slug/_brand/creative-pool'
    | '/brand/$slug/_brand/customer'
    | '/brand/$slug/_brand/design-system'
    | '/brand/$slug/_brand/identity'
    | '/brand/$slug/_brand/products'
    | '/brand/$slug/_brand/site-context'
    | '/brand/$slug/_brand/summary'
    | '/brand/$slug/_brand/team'
    | '/brand/$slug/_brand/testimonials'
    | '/brand/$slug/_brand/visuals'
    | '/brand/$slug/_brand/voice'
    | '/brand/$slug/_brand/voice-samples'
    | '/brand/$slug/brief/confirm'
    | '/brand/$slug/brief/customer'
    | '/brand/$slug/brief/voice'
    | '/brand/$slug/campaigns/$id'
    | '/brand/$slug/campaigns/import'
    | '/brand/$slug/channels/$kind'
    | '/brand/$slug/google-connect/error'
    | '/brand/$slug/google-connect/picker'
    | '/brand/$slug/memos/$memoId'
    | '/brand/$slug/meta-connect/ad-account'
    | '/brand/$slug/meta-connect/error'
    | '/brand/$slug/meta-connect/picker'
    | '/brand/$slug/onboarding/assets'
    | '/brand/$slug/onboarding/competition'
    | '/brand/$slug/onboarding/markets'
    | '/brand/$slug/onboarding/scrape'
    | '/brand/$slug/onboarding/url'
    | '/brand/$slug/settings/ai-tool'
    | '/brand/$slug/settings/authority'
    | '/brand/$slug/settings/communication'
    | '/brand/$slug/settings/danger'
    | '/brand/$slug/settings/integrations'
    | '/brand/$slug/settings/notifications'
    | '/brand/$slug/settings/spend'
    | '/brand/$slug/settings/strategy'
    | '/campaigns/new/drafting/$id'
    | '/campaigns/new/launched/$id'
    | '/campaigns/new/review/$id'
    | '/brand/$slug/brief/'
    | '/brand/$slug/campaigns/'
    | '/brand/$slug/channels/'
    | '/brand/$slug/memos/'
    | '/brand/$slug/settings/'
    | '/brand/$slug/autonomous-actions/$id/veto'
    | '/brand/$slug/campaigns/imported/$id'
    | '/brand/$slug/campaigns/new/brief'
    | '/brand/$slug/campaigns/new/drafting/$id'
    | '/brand/$slug/campaigns/new/launched/$id'
    | '/brand/$slug/campaigns/new/review/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptRoute: typeof AcceptRoute
  ActivityRoute: typeof ActivityRoute
  AnalyticsRoute: typeof AnalyticsRoute
  BrandRoute: typeof BrandRouteWithChildren
  BrandsRoute: typeof BrandsRoute
  BriefRoute: typeof BriefRouteWithChildren
  CampaignsRoute: typeof CampaignsRouteWithChildren
  ChannelsRoute: typeof ChannelsRoute
  CreativeRoute: typeof CreativeRoute
  FollowupsRoute: typeof FollowupsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRouteWithChildren
  HomeRoute: typeof HomeRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  ProfileRoute: typeof ProfileRoute
  ResetPasswordRoute: typeof ResetPasswordRouteWithChildren
  SignupRoute: typeof SignupRoute
  StartRoute: typeof StartRoute
  AdminLlmCostsRoute: typeof AdminLlmCostsRoute
  AdminStrategistRoute: typeof AdminStrategistRoute
  AdminTrustRoute: typeof AdminTrustRoute
  DesignerUploadRoute: typeof DesignerUploadRoute
  DevPreviewRoute: typeof DevPreviewRoute
  DevTemplateProbeRoute: typeof DevTemplateProbeRoute
  DevTemplatesRoute: typeof DevTemplatesRoute
  MagicLinkSentRoute: typeof MagicLinkSentRoute
  McpAuthorizeRoute: typeof McpAuthorizeRoute
  MetaConnectErrorRoute: typeof MetaConnectErrorRoute
  OnboardingPlanRoute: typeof OnboardingPlanRoute
  OnboardingUrlRoute: typeof OnboardingUrlRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  SettingsAdAccountsRoute: typeof SettingsAdAccountsRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  SettingsWorkspaceRoute: typeof SettingsWorkspaceRoute
  VetoTokenRoute: typeof VetoTokenRoute
  DesignerIndexRoute: typeof DesignerIndexRoute
  RenderCreativeIdRoute: typeof RenderCreativeIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/followups': {
      id: '/followups'
      path: '/followups'
      fullPath: '/followups'
      preLoaderRoute: typeof FollowupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creative': {
      id: '/creative'
      path: '/creative'
      fullPath: '/creative'
      preLoaderRoute: typeof CreativeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/channels': {
      id: '/channels'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof ChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brief': {
      id: '/brief'
      path: '/brief'
      fullPath: '/brief'
      preLoaderRoute: typeof BriefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands': {
      id: '/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof BrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brand': {
      id: '/brand'
      path: '/brand'
      fullPath: '/brand'
      preLoaderRoute: typeof BrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept': {
      id: '/accept'
      path: '/accept'
      fullPath: '/accept'
      preLoaderRoute: typeof AcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/designer/': {
      id: '/designer/'
      path: '/designer'
      fullPath: '/designer/'
      preLoaderRoute: typeof DesignerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/veto/$token': {
      id: '/veto/$token'
      path: '/veto/$token'
      fullPath: '/veto/$token'
      preLoaderRoute: typeof VetoTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/workspace': {
      id: '/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof SettingsWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/team': {
      id: '/settings/team'
      path: '/settings/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ad-accounts': {
      id: '/settings/ad-accounts'
      path: '/settings/ad-accounts'
      fullPath: '/settings/ad-accounts'
      preLoaderRoute: typeof SettingsAdAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/success': {
      id: '/reset-password/success'
      path: '/success'
      fullPath: '/reset-password/success'
      preLoaderRoute: typeof ResetPasswordSuccessRouteImport
      parentRoute: typeof ResetPasswordRoute
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/onboarding/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/url': {
      id: '/onboarding/url'
      path: '/onboarding/url'
      fullPath: '/onboarding/url'
      preLoaderRoute: typeof OnboardingUrlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/plan': {
      id: '/onboarding/plan'
      path: '/onboarding/plan'
      fullPath: '/onboarding/plan'
      preLoaderRoute: typeof OnboardingPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meta-connect/error': {
      id: '/meta-connect/error'
      path: '/meta-connect/error'
      fullPath: '/meta-connect/error'
      preLoaderRoute: typeof MetaConnectErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp/authorize': {
      id: '/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/mcp/authorize'
      preLoaderRoute: typeof McpAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-link/sent': {
      id: '/magic-link/sent'
      path: '/magic-link/sent'
      fullPath: '/magic-link/sent'
      preLoaderRoute: typeof MagicLinkSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/sent': {
      id: '/forgot-password/sent'
      path: '/sent'
      fullPath: '/forgot-password/sent'
      preLoaderRoute: typeof ForgotPasswordSentRouteImport
      parentRoute: typeof ForgotPasswordRoute
    }
    '/dev/templates': {
      id: '/dev/templates'
      path: '/dev/templates'
      fullPath: '/dev/templates'
      preLoaderRoute: typeof DevTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/template-probe': {
      id: '/dev/template-probe'
      path: '/dev/template-probe'
      fullPath: '/dev/template-probe'
      preLoaderRoute: typeof DevTemplateProbeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/preview': {
      id: '/dev/preview'
      path: '/dev/preview'
      fullPath: '/dev/preview'
      preLoaderRoute: typeof DevPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/designer/upload': {
      id: '/designer/upload'
      path: '/designer/upload'
      fullPath: '/designer/upload'
      preLoaderRoute: typeof DesignerUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/import': {
      id: '/campaigns/import'
      path: '/import'
      fullPath: '/campaigns/import'
      preLoaderRoute: typeof CampaignsImportRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/brief/voice': {
      id: '/brief/voice'
      path: '/voice'
      fullPath: '/brief/voice'
      preLoaderRoute: typeof BriefVoiceRouteImport
      parentRoute: typeof BriefRoute
    }
    '/brief/customer': {
      id: '/brief/customer'
      path: '/customer'
      fullPath: '/brief/customer'
      preLoaderRoute: typeof BriefCustomerRouteImport
      parentRoute: typeof BriefRoute
    }
    '/brand/$slug': {
      id: '/brand/$slug'
      path: '/$slug'
      fullPath: '/brand/$slug'
      preLoaderRoute: typeof BrandSlugRouteImport
      parentRoute: typeof BrandRoute
    }
    '/admin/trust': {
      id: '/admin/trust'
      path: '/admin/trust'
      fullPath: '/admin/trust'
      preLoaderRoute: typeof AdminTrustRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/strategist': {
      id: '/admin/strategist'
      path: '/admin/strategist'
      fullPath: '/admin/strategist'
      preLoaderRoute: typeof AdminStrategistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/llm-costs': {
      id: '/admin/llm-costs'
      path: '/admin/llm-costs'
      fullPath: '/admin/llm-costs'
      preLoaderRoute: typeof AdminLlmCostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/render/creative/$id': {
      id: '/render/creative/$id'
      path: '/render/creative/$id'
      fullPath: '/render/creative/$id'
      preLoaderRoute: typeof RenderCreativeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/new/brief': {
      id: '/campaigns/new/brief'
      path: '/new/brief'
      fullPath: '/campaigns/new/brief'
      preLoaderRoute: typeof CampaignsNewBriefRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/imported/$id': {
      id: '/campaigns/imported/$id'
      path: '/imported/$id'
      fullPath: '/campaigns/imported/$id'
      preLoaderRoute: typeof CampaignsImportedIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/brand/$slug/site': {
      id: '/brand/$slug/site'
      path: '/site'
      fullPath: '/brand/$slug/site'
      preLoaderRoute: typeof BrandSlugSiteRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/settings': {
      id: '/brand/$slug/settings'
      path: '/settings'
      fullPath: '/brand/$slug/settings'
      preLoaderRoute: typeof BrandSlugSettingsRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/library': {
      id: '/brand/$slug/library'
      path: '/library'
      fullPath: '/brand/$slug/library'
      preLoaderRoute: typeof BrandSlugLibraryRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/home': {
      id: '/brand/$slug/home'
      path: '/home'
      fullPath: '/brand/$slug/home'
      preLoaderRoute: typeof BrandSlugHomeRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/followups': {
      id: '/brand/$slug/followups'
      path: '/followups'
      fullPath: '/brand/$slug/followups'
      preLoaderRoute: typeof BrandSlugFollowupsRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/creative': {
      id: '/brand/$slug/creative'
      path: '/creative'
      fullPath: '/brand/$slug/creative'
      preLoaderRoute: typeof BrandSlugCreativeRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/campaigns': {
      id: '/brand/$slug/campaigns'
      path: '/campaigns'
      fullPath: '/brand/$slug/campaigns'
      preLoaderRoute: typeof BrandSlugCampaignsRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/calendar': {
      id: '/brand/$slug/calendar'
      path: '/calendar'
      fullPath: '/brand/$slug/calendar'
      preLoaderRoute: typeof BrandSlugCalendarRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/brief': {
      id: '/brand/$slug/brief'
      path: '/brief'
      fullPath: '/brand/$slug/brief'
      preLoaderRoute: typeof BrandSlugBriefRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/analytics': {
      id: '/brand/$slug/analytics'
      path: '/analytics'
      fullPath: '/brand/$slug/analytics'
      preLoaderRoute: typeof BrandSlugAnalyticsRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/_brand': {
      id: '/brand/$slug/_brand'
      path: ''
      fullPath: '/brand/$slug'
      preLoaderRoute: typeof BrandSlugBrandRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/settings/': {
      id: '/brand/$slug/settings/'
      path: '/'
      fullPath: '/brand/$slug/settings/'
      preLoaderRoute: typeof BrandSlugSettingsIndexRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/memos/': {
      id: '/brand/$slug/memos/'
      path: '/memos'
      fullPath: '/brand/$slug/memos/'
      preLoaderRoute: typeof BrandSlugMemosIndexRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/channels/': {
      id: '/brand/$slug/channels/'
      path: '/channels'
      fullPath: '/brand/$slug/channels/'
      preLoaderRoute: typeof BrandSlugChannelsIndexRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/campaigns/': {
      id: '/brand/$slug/campaigns/'
      path: '/'
      fullPath: '/brand/$slug/campaigns/'
      preLoaderRoute: typeof BrandSlugCampaignsIndexRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/brief/': {
      id: '/brand/$slug/brief/'
      path: '/'
      fullPath: '/brand/$slug/brief/'
      preLoaderRoute: typeof BrandSlugBriefIndexRouteImport
      parentRoute: typeof BrandSlugBriefRoute
    }
    '/campaigns/new/review/$id': {
      id: '/campaigns/new/review/$id'
      path: '/new/review/$id'
      fullPath: '/campaigns/new/review/$id'
      preLoaderRoute: typeof CampaignsNewReviewIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/new/launched/$id': {
      id: '/campaigns/new/launched/$id'
      path: '/new/launched/$id'
      fullPath: '/campaigns/new/launched/$id'
      preLoaderRoute: typeof CampaignsNewLaunchedIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/new/drafting/$id': {
      id: '/campaigns/new/drafting/$id'
      path: '/new/drafting/$id'
      fullPath: '/campaigns/new/drafting/$id'
      preLoaderRoute: typeof CampaignsNewDraftingIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/brand/$slug/settings/strategy': {
      id: '/brand/$slug/settings/strategy'
      path: '/strategy'
      fullPath: '/brand/$slug/settings/strategy'
      preLoaderRoute: typeof BrandSlugSettingsStrategyRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/spend': {
      id: '/brand/$slug/settings/spend'
      path: '/spend'
      fullPath: '/brand/$slug/settings/spend'
      preLoaderRoute: typeof BrandSlugSettingsSpendRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/notifications': {
      id: '/brand/$slug/settings/notifications'
      path: '/notifications'
      fullPath: '/brand/$slug/settings/notifications'
      preLoaderRoute: typeof BrandSlugSettingsNotificationsRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/integrations': {
      id: '/brand/$slug/settings/integrations'
      path: '/integrations'
      fullPath: '/brand/$slug/settings/integrations'
      preLoaderRoute: typeof BrandSlugSettingsIntegrationsRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/danger': {
      id: '/brand/$slug/settings/danger'
      path: '/danger'
      fullPath: '/brand/$slug/settings/danger'
      preLoaderRoute: typeof BrandSlugSettingsDangerRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/communication': {
      id: '/brand/$slug/settings/communication'
      path: '/communication'
      fullPath: '/brand/$slug/settings/communication'
      preLoaderRoute: typeof BrandSlugSettingsCommunicationRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/authority': {
      id: '/brand/$slug/settings/authority'
      path: '/authority'
      fullPath: '/brand/$slug/settings/authority'
      preLoaderRoute: typeof BrandSlugSettingsAuthorityRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/settings/ai-tool': {
      id: '/brand/$slug/settings/ai-tool'
      path: '/ai-tool'
      fullPath: '/brand/$slug/settings/ai-tool'
      preLoaderRoute: typeof BrandSlugSettingsAiToolRouteImport
      parentRoute: typeof BrandSlugSettingsRoute
    }
    '/brand/$slug/onboarding/url': {
      id: '/brand/$slug/onboarding/url'
      path: '/onboarding/url'
      fullPath: '/brand/$slug/onboarding/url'
      preLoaderRoute: typeof BrandSlugOnboardingUrlRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/onboarding/scrape': {
      id: '/brand/$slug/onboarding/scrape'
      path: '/onboarding/scrape'
      fullPath: '/brand/$slug/onboarding/scrape'
      preLoaderRoute: typeof BrandSlugOnboardingScrapeRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/onboarding/markets': {
      id: '/brand/$slug/onboarding/markets'
      path: '/onboarding/markets'
      fullPath: '/brand/$slug/onboarding/markets'
      preLoaderRoute: typeof BrandSlugOnboardingMarketsRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/onboarding/competition': {
      id: '/brand/$slug/onboarding/competition'
      path: '/onboarding/competition'
      fullPath: '/brand/$slug/onboarding/competition'
      preLoaderRoute: typeof BrandSlugOnboardingCompetitionRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/onboarding/assets': {
      id: '/brand/$slug/onboarding/assets'
      path: '/onboarding/assets'
      fullPath: '/brand/$slug/onboarding/assets'
      preLoaderRoute: typeof BrandSlugOnboardingAssetsRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/meta-connect/picker': {
      id: '/brand/$slug/meta-connect/picker'
      path: '/meta-connect/picker'
      fullPath: '/brand/$slug/meta-connect/picker'
      preLoaderRoute: typeof BrandSlugMetaConnectPickerRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/meta-connect/error': {
      id: '/brand/$slug/meta-connect/error'
      path: '/meta-connect/error'
      fullPath: '/brand/$slug/meta-connect/error'
      preLoaderRoute: typeof BrandSlugMetaConnectErrorRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/meta-connect/ad-account': {
      id: '/brand/$slug/meta-connect/ad-account'
      path: '/meta-connect/ad-account'
      fullPath: '/brand/$slug/meta-connect/ad-account'
      preLoaderRoute: typeof BrandSlugMetaConnectAdAccountRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/memos/$memoId': {
      id: '/brand/$slug/memos/$memoId'
      path: '/memos/$memoId'
      fullPath: '/brand/$slug/memos/$memoId'
      preLoaderRoute: typeof BrandSlugMemosMemoIdRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/google-connect/picker': {
      id: '/brand/$slug/google-connect/picker'
      path: '/google-connect/picker'
      fullPath: '/brand/$slug/google-connect/picker'
      preLoaderRoute: typeof BrandSlugGoogleConnectPickerRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/google-connect/error': {
      id: '/brand/$slug/google-connect/error'
      path: '/google-connect/error'
      fullPath: '/brand/$slug/google-connect/error'
      preLoaderRoute: typeof BrandSlugGoogleConnectErrorRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/channels/$kind': {
      id: '/brand/$slug/channels/$kind'
      path: '/channels/$kind'
      fullPath: '/brand/$slug/channels/$kind'
      preLoaderRoute: typeof BrandSlugChannelsKindRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/campaigns/import': {
      id: '/brand/$slug/campaigns/import'
      path: '/import'
      fullPath: '/brand/$slug/campaigns/import'
      preLoaderRoute: typeof BrandSlugCampaignsImportRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/campaigns/$id': {
      id: '/brand/$slug/campaigns/$id'
      path: '/$id'
      fullPath: '/brand/$slug/campaigns/$id'
      preLoaderRoute: typeof BrandSlugCampaignsIdRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/brief/voice': {
      id: '/brand/$slug/brief/voice'
      path: '/voice'
      fullPath: '/brand/$slug/brief/voice'
      preLoaderRoute: typeof BrandSlugBriefVoiceRouteImport
      parentRoute: typeof BrandSlugBriefRoute
    }
    '/brand/$slug/brief/customer': {
      id: '/brand/$slug/brief/customer'
      path: '/customer'
      fullPath: '/brand/$slug/brief/customer'
      preLoaderRoute: typeof BrandSlugBriefCustomerRouteImport
      parentRoute: typeof BrandSlugBriefRoute
    }
    '/brand/$slug/brief/confirm': {
      id: '/brand/$slug/brief/confirm'
      path: '/confirm'
      fullPath: '/brand/$slug/brief/confirm'
      preLoaderRoute: typeof BrandSlugBriefConfirmRouteImport
      parentRoute: typeof BrandSlugBriefRoute
    }
    '/brand/$slug/_brand/voice-samples': {
      id: '/brand/$slug/_brand/voice-samples'
      path: '/voice-samples'
      fullPath: '/brand/$slug/voice-samples'
      preLoaderRoute: typeof BrandSlugBrandVoiceSamplesRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/voice': {
      id: '/brand/$slug/_brand/voice'
      path: '/voice'
      fullPath: '/brand/$slug/voice'
      preLoaderRoute: typeof BrandSlugBrandVoiceRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/visuals': {
      id: '/brand/$slug/_brand/visuals'
      path: '/visuals'
      fullPath: '/brand/$slug/visuals'
      preLoaderRoute: typeof BrandSlugBrandVisualsRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/testimonials': {
      id: '/brand/$slug/_brand/testimonials'
      path: '/testimonials'
      fullPath: '/brand/$slug/testimonials'
      preLoaderRoute: typeof BrandSlugBrandTestimonialsRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/team': {
      id: '/brand/$slug/_brand/team'
      path: '/team'
      fullPath: '/brand/$slug/team'
      preLoaderRoute: typeof BrandSlugBrandTeamRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/summary': {
      id: '/brand/$slug/_brand/summary'
      path: '/summary'
      fullPath: '/brand/$slug/summary'
      preLoaderRoute: typeof BrandSlugBrandSummaryRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/site-context': {
      id: '/brand/$slug/_brand/site-context'
      path: '/site-context'
      fullPath: '/brand/$slug/site-context'
      preLoaderRoute: typeof BrandSlugBrandSiteContextRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/products': {
      id: '/brand/$slug/_brand/products'
      path: '/products'
      fullPath: '/brand/$slug/products'
      preLoaderRoute: typeof BrandSlugBrandProductsRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/identity': {
      id: '/brand/$slug/_brand/identity'
      path: '/identity'
      fullPath: '/brand/$slug/identity'
      preLoaderRoute: typeof BrandSlugBrandIdentityRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/design-system': {
      id: '/brand/$slug/_brand/design-system'
      path: '/design-system'
      fullPath: '/brand/$slug/design-system'
      preLoaderRoute: typeof BrandSlugBrandDesignSystemRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/customer': {
      id: '/brand/$slug/_brand/customer'
      path: '/customer'
      fullPath: '/brand/$slug/customer'
      preLoaderRoute: typeof BrandSlugBrandCustomerRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/creative-pool': {
      id: '/brand/$slug/_brand/creative-pool'
      path: '/creative-pool'
      fullPath: '/brand/$slug/creative-pool'
      preLoaderRoute: typeof BrandSlugBrandCreativePoolRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/competition': {
      id: '/brand/$slug/_brand/competition'
      path: '/competition'
      fullPath: '/brand/$slug/competition'
      preLoaderRoute: typeof BrandSlugBrandCompetitionRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/_brand/assets': {
      id: '/brand/$slug/_brand/assets'
      path: '/assets'
      fullPath: '/brand/$slug/assets'
      preLoaderRoute: typeof BrandSlugBrandAssetsRouteImport
      parentRoute: typeof BrandSlugBrandRoute
    }
    '/brand/$slug/campaigns/new/brief': {
      id: '/brand/$slug/campaigns/new/brief'
      path: '/new/brief'
      fullPath: '/brand/$slug/campaigns/new/brief'
      preLoaderRoute: typeof BrandSlugCampaignsNewBriefRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/campaigns/imported/$id': {
      id: '/brand/$slug/campaigns/imported/$id'
      path: '/imported/$id'
      fullPath: '/brand/$slug/campaigns/imported/$id'
      preLoaderRoute: typeof BrandSlugCampaignsImportedIdRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/autonomous-actions/$id/veto': {
      id: '/brand/$slug/autonomous-actions/$id/veto'
      path: '/autonomous-actions/$id/veto'
      fullPath: '/brand/$slug/autonomous-actions/$id/veto'
      preLoaderRoute: typeof BrandSlugAutonomousActionsIdVetoRouteImport
      parentRoute: typeof BrandSlugRoute
    }
    '/brand/$slug/campaigns/new/review/$id': {
      id: '/brand/$slug/campaigns/new/review/$id'
      path: '/new/review/$id'
      fullPath: '/brand/$slug/campaigns/new/review/$id'
      preLoaderRoute: typeof BrandSlugCampaignsNewReviewIdRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/campaigns/new/launched/$id': {
      id: '/brand/$slug/campaigns/new/launched/$id'
      path: '/new/launched/$id'
      fullPath: '/brand/$slug/campaigns/new/launched/$id'
      preLoaderRoute: typeof BrandSlugCampaignsNewLaunchedIdRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
    '/brand/$slug/campaigns/new/drafting/$id': {
      id: '/brand/$slug/campaigns/new/drafting/$id'
      path: '/new/drafting/$id'
      fullPath: '/brand/$slug/campaigns/new/drafting/$id'
      preLoaderRoute: typeof BrandSlugCampaignsNewDraftingIdRouteImport
      parentRoute: typeof BrandSlugCampaignsRoute
    }
  }
}

interface BrandSlugBrandRouteChildren {
  BrandSlugBrandAssetsRoute: typeof BrandSlugBrandAssetsRoute
  BrandSlugBrandCompetitionRoute: typeof BrandSlugBrandCompetitionRoute
  BrandSlugBrandCreativePoolRoute: typeof BrandSlugBrandCreativePoolRoute
  BrandSlugBrandCustomerRoute: typeof BrandSlugBrandCustomerRoute
  BrandSlugBrandDesignSystemRoute: typeof BrandSlugBrandDesignSystemRoute
  BrandSlugBrandIdentityRoute: typeof BrandSlugBrandIdentityRoute
  BrandSlugBrandProductsRoute: typeof BrandSlugBrandProductsRoute
  BrandSlugBrandSiteContextRoute: typeof BrandSlugBrandSiteContextRoute
  BrandSlugBrandSummaryRoute: typeof BrandSlugBrandSummaryRoute
  BrandSlugBrandTeamRoute: typeof BrandSlugBrandTeamRoute
  BrandSlugBrandTestimonialsRoute: typeof BrandSlugBrandTestimonialsRoute
  BrandSlugBrandVisualsRoute: typeof BrandSlugBrandVisualsRoute
  BrandSlugBrandVoiceRoute: typeof BrandSlugBrandVoiceRoute
  BrandSlugBrandVoiceSamplesRoute: typeof BrandSlugBrandVoiceSamplesRoute
}

const BrandSlugBrandRouteChildren: BrandSlugBrandRouteChildren = {
  BrandSlugBrandAssetsRoute: BrandSlugBrandAssetsRoute,
  BrandSlugBrandCompetitionRoute: BrandSlugBrandCompetitionRoute,
  BrandSlugBrandCreativePoolRoute: BrandSlugBrandCreativePoolRoute,
  BrandSlugBrandCustomerRoute: BrandSlugBrandCustomerRoute,
  BrandSlugBrandDesignSystemRoute: BrandSlugBrandDesignSystemRoute,
  BrandSlugBrandIdentityRoute: BrandSlugBrandIdentityRoute,
  BrandSlugBrandProductsRoute: BrandSlugBrandProductsRoute,
  BrandSlugBrandSiteContextRoute: BrandSlugBrandSiteContextRoute,
  BrandSlugBrandSummaryRoute: BrandSlugBrandSummaryRoute,
  BrandSlugBrandTeamRoute: BrandSlugBrandTeamRoute,
  BrandSlugBrandTestimonialsRoute: BrandSlugBrandTestimonialsRoute,
  BrandSlugBrandVisualsRoute: BrandSlugBrandVisualsRoute,
  BrandSlugBrandVoiceRoute: BrandSlugBrandVoiceRoute,
  BrandSlugBrandVoiceSamplesRoute: BrandSlugBrandVoiceSamplesRoute,
}

const BrandSlugBrandRouteWithChildren = BrandSlugBrandRoute._addFileChildren(
  BrandSlugBrandRouteChildren,
)

interface BrandSlugBriefRouteChildren {
  BrandSlugBriefConfirmRoute: typeof BrandSlugBriefConfirmRoute
  BrandSlugBriefCustomerRoute: typeof BrandSlugBriefCustomerRoute
  BrandSlugBriefVoiceRoute: typeof BrandSlugBriefVoiceRoute
  BrandSlugBriefIndexRoute: typeof BrandSlugBriefIndexRoute
}

const BrandSlugBriefRouteChildren: BrandSlugBriefRouteChildren = {
  BrandSlugBriefConfirmRoute: BrandSlugBriefConfirmRoute,
  BrandSlugBriefCustomerRoute: BrandSlugBriefCustomerRoute,
  BrandSlugBriefVoiceRoute: BrandSlugBriefVoiceRoute,
  BrandSlugBriefIndexRoute: BrandSlugBriefIndexRoute,
}

const BrandSlugBriefRouteWithChildren = BrandSlugBriefRoute._addFileChildren(
  BrandSlugBriefRouteChildren,
)

interface BrandSlugCampaignsRouteChildren {
  BrandSlugCampaignsIdRoute: typeof BrandSlugCampaignsIdRoute
  BrandSlugCampaignsImportRoute: typeof BrandSlugCampaignsImportRoute
  BrandSlugCampaignsIndexRoute: typeof BrandSlugCampaignsIndexRoute
  BrandSlugCampaignsImportedIdRoute: typeof BrandSlugCampaignsImportedIdRoute
  BrandSlugCampaignsNewBriefRoute: typeof BrandSlugCampaignsNewBriefRoute
  BrandSlugCampaignsNewDraftingIdRoute: typeof BrandSlugCampaignsNewDraftingIdRoute
  BrandSlugCampaignsNewLaunchedIdRoute: typeof BrandSlugCampaignsNewLaunchedIdRoute
  BrandSlugCampaignsNewReviewIdRoute: typeof BrandSlugCampaignsNewReviewIdRoute
}

const BrandSlugCampaignsRouteChildren: BrandSlugCampaignsRouteChildren = {
  BrandSlugCampaignsIdRoute: BrandSlugCampaignsIdRoute,
  BrandSlugCampaignsImportRoute: BrandSlugCampaignsImportRoute,
  BrandSlugCampaignsIndexRoute: BrandSlugCampaignsIndexRoute,
  BrandSlugCampaignsImportedIdRoute: BrandSlugCampaignsImportedIdRoute,
  BrandSlugCampaignsNewBriefRoute: BrandSlugCampaignsNewBriefRoute,
  BrandSlugCampaignsNewDraftingIdRoute: BrandSlugCampaignsNewDraftingIdRoute,
  BrandSlugCampaignsNewLaunchedIdRoute: BrandSlugCampaignsNewLaunchedIdRoute,
  BrandSlugCampaignsNewReviewIdRoute: BrandSlugCampaignsNewReviewIdRoute,
}

const BrandSlugCampaignsRouteWithChildren =
  BrandSlugCampaignsRoute._addFileChildren(BrandSlugCampaignsRouteChildren)

interface BrandSlugSettingsRouteChildren {
  BrandSlugSettingsAiToolRoute: typeof BrandSlugSettingsAiToolRoute
  BrandSlugSettingsAuthorityRoute: typeof BrandSlugSettingsAuthorityRoute
  BrandSlugSettingsCommunicationRoute: typeof BrandSlugSettingsCommunicationRoute
  BrandSlugSettingsDangerRoute: typeof BrandSlugSettingsDangerRoute
  BrandSlugSettingsIntegrationsRoute: typeof BrandSlugSettingsIntegrationsRoute
  BrandSlugSettingsNotificationsRoute: typeof BrandSlugSettingsNotificationsRoute
  BrandSlugSettingsSpendRoute: typeof BrandSlugSettingsSpendRoute
  BrandSlugSettingsStrategyRoute: typeof BrandSlugSettingsStrategyRoute
  BrandSlugSettingsIndexRoute: typeof BrandSlugSettingsIndexRoute
}

const BrandSlugSettingsRouteChildren: BrandSlugSettingsRouteChildren = {
  BrandSlugSettingsAiToolRoute: BrandSlugSettingsAiToolRoute,
  BrandSlugSettingsAuthorityRoute: BrandSlugSettingsAuthorityRoute,
  BrandSlugSettingsCommunicationRoute: BrandSlugSettingsCommunicationRoute,
  BrandSlugSettingsDangerRoute: BrandSlugSettingsDangerRoute,
  BrandSlugSettingsIntegrationsRoute: BrandSlugSettingsIntegrationsRoute,
  BrandSlugSettingsNotificationsRoute: BrandSlugSettingsNotificationsRoute,
  BrandSlugSettingsSpendRoute: BrandSlugSettingsSpendRoute,
  BrandSlugSettingsStrategyRoute: BrandSlugSettingsStrategyRoute,
  BrandSlugSettingsIndexRoute: BrandSlugSettingsIndexRoute,
}

const BrandSlugSettingsRouteWithChildren =
  BrandSlugSettingsRoute._addFileChildren(BrandSlugSettingsRouteChildren)

interface BrandSlugRouteChildren {
  BrandSlugBrandRoute: typeof BrandSlugBrandRouteWithChildren
  BrandSlugAnalyticsRoute: typeof BrandSlugAnalyticsRoute
  BrandSlugBriefRoute: typeof BrandSlugBriefRouteWithChildren
  BrandSlugCalendarRoute: typeof BrandSlugCalendarRoute
  BrandSlugCampaignsRoute: typeof BrandSlugCampaignsRouteWithChildren
  BrandSlugCreativeRoute: typeof BrandSlugCreativeRoute
  BrandSlugFollowupsRoute: typeof BrandSlugFollowupsRoute
  BrandSlugHomeRoute: typeof BrandSlugHomeRoute
  BrandSlugLibraryRoute: typeof BrandSlugLibraryRoute
  BrandSlugSettingsRoute: typeof BrandSlugSettingsRouteWithChildren
  BrandSlugSiteRoute: typeof BrandSlugSiteRoute
  BrandSlugChannelsKindRoute: typeof BrandSlugChannelsKindRoute
  BrandSlugGoogleConnectErrorRoute: typeof BrandSlugGoogleConnectErrorRoute
  BrandSlugGoogleConnectPickerRoute: typeof BrandSlugGoogleConnectPickerRoute
  BrandSlugMemosMemoIdRoute: typeof BrandSlugMemosMemoIdRoute
  BrandSlugMetaConnectAdAccountRoute: typeof BrandSlugMetaConnectAdAccountRoute
  BrandSlugMetaConnectErrorRoute: typeof BrandSlugMetaConnectErrorRoute
  BrandSlugMetaConnectPickerRoute: typeof BrandSlugMetaConnectPickerRoute
  BrandSlugOnboardingAssetsRoute: typeof BrandSlugOnboardingAssetsRoute
  BrandSlugOnboardingCompetitionRoute: typeof BrandSlugOnboardingCompetitionRoute
  BrandSlugOnboardingMarketsRoute: typeof BrandSlugOnboardingMarketsRoute
  BrandSlugOnboardingScrapeRoute: typeof BrandSlugOnboardingScrapeRoute
  BrandSlugOnboardingUrlRoute: typeof BrandSlugOnboardingUrlRoute
  BrandSlugChannelsIndexRoute: typeof BrandSlugChannelsIndexRoute
  BrandSlugMemosIndexRoute: typeof BrandSlugMemosIndexRoute
  BrandSlugAutonomousActionsIdVetoRoute: typeof BrandSlugAutonomousActionsIdVetoRoute
}

const BrandSlugRouteChildren: BrandSlugRouteChildren = {
  BrandSlugBrandRoute: BrandSlugBrandRouteWithChildren,
  BrandSlugAnalyticsRoute: BrandSlugAnalyticsRoute,
  BrandSlugBriefRoute: BrandSlugBriefRouteWithChildren,
  BrandSlugCalendarRoute: BrandSlugCalendarRoute,
  BrandSlugCampaignsRoute: BrandSlugCampaignsRouteWithChildren,
  BrandSlugCreativeRoute: BrandSlugCreativeRoute,
  BrandSlugFollowupsRoute: BrandSlugFollowupsRoute,
  BrandSlugHomeRoute: BrandSlugHomeRoute,
  BrandSlugLibraryRoute: BrandSlugLibraryRoute,
  BrandSlugSettingsRoute: BrandSlugSettingsRouteWithChildren,
  BrandSlugSiteRoute: BrandSlugSiteRoute,
  BrandSlugChannelsKindRoute: BrandSlugChannelsKindRoute,
  BrandSlugGoogleConnectErrorRoute: BrandSlugGoogleConnectErrorRoute,
  BrandSlugGoogleConnectPickerRoute: BrandSlugGoogleConnectPickerRoute,
  BrandSlugMemosMemoIdRoute: BrandSlugMemosMemoIdRoute,
  BrandSlugMetaConnectAdAccountRoute: BrandSlugMetaConnectAdAccountRoute,
  BrandSlugMetaConnectErrorRoute: BrandSlugMetaConnectErrorRoute,
  BrandSlugMetaConnectPickerRoute: BrandSlugMetaConnectPickerRoute,
  BrandSlugOnboardingAssetsRoute: BrandSlugOnboardingAssetsRoute,
  BrandSlugOnboardingCompetitionRoute: BrandSlugOnboardingCompetitionRoute,
  BrandSlugOnboardingMarketsRoute: BrandSlugOnboardingMarketsRoute,
  BrandSlugOnboardingScrapeRoute: BrandSlugOnboardingScrapeRoute,
  BrandSlugOnboardingUrlRoute: BrandSlugOnboardingUrlRoute,
  BrandSlugChannelsIndexRoute: BrandSlugChannelsIndexRoute,
  BrandSlugMemosIndexRoute: BrandSlugMemosIndexRoute,
  BrandSlugAutonomousActionsIdVetoRoute: BrandSlugAutonomousActionsIdVetoRoute,
}

const BrandSlugRouteWithChildren = BrandSlugRoute._addFileChildren(
  BrandSlugRouteChildren,
)

interface BrandRouteChildren {
  BrandSlugRoute: typeof BrandSlugRouteWithChildren
}

const BrandRouteChildren: BrandRouteChildren = {
  BrandSlugRoute: BrandSlugRouteWithChildren,
}

const BrandRouteWithChildren = BrandRoute._addFileChildren(BrandRouteChildren)

interface BriefRouteChildren {
  BriefCustomerRoute: typeof BriefCustomerRoute
  BriefVoiceRoute: typeof BriefVoiceRoute
}

const BriefRouteChildren: BriefRouteChildren = {
  BriefCustomerRoute: BriefCustomerRoute,
  BriefVoiceRoute: BriefVoiceRoute,
}

const BriefRouteWithChildren = BriefRoute._addFileChildren(BriefRouteChildren)

interface CampaignsRouteChildren {
  CampaignsImportRoute: typeof CampaignsImportRoute
  CampaignsImportedIdRoute: typeof CampaignsImportedIdRoute
  CampaignsNewBriefRoute: typeof CampaignsNewBriefRoute
  CampaignsNewDraftingIdRoute: typeof CampaignsNewDraftingIdRoute
  CampaignsNewLaunchedIdRoute: typeof CampaignsNewLaunchedIdRoute
  CampaignsNewReviewIdRoute: typeof CampaignsNewReviewIdRoute
}

const CampaignsRouteChildren: CampaignsRouteChildren = {
  CampaignsImportRoute: CampaignsImportRoute,
  CampaignsImportedIdRoute: CampaignsImportedIdRoute,
  CampaignsNewBriefRoute: CampaignsNewBriefRoute,
  CampaignsNewDraftingIdRoute: CampaignsNewDraftingIdRoute,
  CampaignsNewLaunchedIdRoute: CampaignsNewLaunchedIdRoute,
  CampaignsNewReviewIdRoute: CampaignsNewReviewIdRoute,
}

const CampaignsRouteWithChildren = CampaignsRoute._addFileChildren(
  CampaignsRouteChildren,
)

interface ForgotPasswordRouteChildren {
  ForgotPasswordSentRoute: typeof ForgotPasswordSentRoute
}

const ForgotPasswordRouteChildren: ForgotPasswordRouteChildren = {
  ForgotPasswordSentRoute: ForgotPasswordSentRoute,
}

const ForgotPasswordRouteWithChildren = ForgotPasswordRoute._addFileChildren(
  ForgotPasswordRouteChildren,
)

interface ResetPasswordRouteChildren {
  ResetPasswordSuccessRoute: typeof ResetPasswordSuccessRoute
}

const ResetPasswordRouteChildren: ResetPasswordRouteChildren = {
  ResetPasswordSuccessRoute: ResetPasswordSuccessRoute,
}

const ResetPasswordRouteWithChildren = ResetPasswordRoute._addFileChildren(
  ResetPasswordRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptRoute: AcceptRoute,
  ActivityRoute: ActivityRoute,
  AnalyticsRoute: AnalyticsRoute,
  BrandRoute: BrandRouteWithChildren,
  BrandsRoute: BrandsRoute,
  BriefRoute: BriefRouteWithChildren,
  CampaignsRoute: CampaignsRouteWithChildren,
  ChannelsRoute: ChannelsRoute,
  CreativeRoute: CreativeRoute,
  FollowupsRoute: FollowupsRoute,
  ForgotPasswordRoute: ForgotPasswordRouteWithChildren,
  HomeRoute: HomeRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  ProfileRoute: ProfileRoute,
  ResetPasswordRoute: ResetPasswordRouteWithChildren,
  SignupRoute: SignupRoute,
  StartRoute: StartRoute,
  AdminLlmCostsRoute: AdminLlmCostsRoute,
  AdminStrategistRoute: AdminStrategistRoute,
  AdminTrustRoute: AdminTrustRoute,
  DesignerUploadRoute: DesignerUploadRoute,
  DevPreviewRoute: DevPreviewRoute,
  DevTemplateProbeRoute: DevTemplateProbeRoute,
  DevTemplatesRoute: DevTemplatesRoute,
  MagicLinkSentRoute: MagicLinkSentRoute,
  McpAuthorizeRoute: McpAuthorizeRoute,
  MetaConnectErrorRoute: MetaConnectErrorRoute,
  OnboardingPlanRoute: OnboardingPlanRoute,
  OnboardingUrlRoute: OnboardingUrlRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  SettingsAdAccountsRoute: SettingsAdAccountsRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  SettingsWorkspaceRoute: SettingsWorkspaceRoute,
  VetoTokenRoute: VetoTokenRoute,
  DesignerIndexRoute: DesignerIndexRoute,
  RenderCreativeIdRoute: RenderCreativeIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
